import t from "prop-types";

import { css } from "@emotion/react";
import { Tooltip } from "@material-ui/core";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

const muiTheme = createMuiTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: "12px",
        color: "white",
        backgroundColor: "#0F1140",
        fontFamily: "'Rubik', sans-serif",
      },
      arrow: {
        color: "#0F1140",
      },
    },
  },
});

const propTypes = {
  icon: t.element,
  isActive: t.bool,
  onClick: t.func,
  type: t.string,
  name: t.oneOfType([t.string, t.element, t.object]).isRequired,
  id: t.string,
};

const rootStyle = theme => css`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  &:hover:not(.active) {
    background-color: ${theme.colors.surface.main};
    cursor: pointer;
    svg {
      fill: ${theme.colors.primary.dark};
      * {
        stroke: ${theme.colors.primary.dark};
      }po
    }
  }
  svg { 
    fill: ${theme.colors.white};
    * {
      stroke: ${theme.colors.white};
    }
  }
  &.active {
    background-color: ${theme.colors.surface.white};
    * {
      stroke: ${theme.colors.primary.dark};
    }
    cursor: default;
  }
`;

const customStyle = theme => css`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;

  svg {
    width: 80%;
    height: 80%;
  }

  circle, rect, path {
    stroke-width: 1.1px;
  }

  &:hover:not(.active) {
    cursor: pointer;
  }

  &.active {
    cursor: default;
  }

  &.active, &:hover:not(.active) {
    background-color: ${theme.colors.surface.white};
    path {
      fill: ${theme.colors.primary.dark};
    }
    circle {
      stroke: ${theme.colors.primary.dark};
    }
    rect {
      stroke: ${theme.colors.primary.dark};
    }
  }
`;

const NavIcon = (props) => {
  const { icon, isActive = false, onClick, type, name, id = "", disableFill } = props;
  
  const handleClick = e => {
    onClick && onClick(e, type);
  };

  return (
    <MuiThemeProvider theme={muiTheme}>
      <Tooltip title={name} arrow placement="right">
        <div
          id={id}
          css={disableFill ? customStyle : rootStyle}
          className={`${isActive ? "active" : ""}`}
          onClick={handleClick}
          data-cy={id}
        >
          {icon}
        </div>
      </Tooltip>
    </MuiThemeProvider>
  );
};

NavIcon.propTypes = propTypes;

export default NavIcon;
